import React from 'react'
import { useSelector } from 'react-redux'
import { Icon } from 'icons'
import * as S from './pdfElements'
import {
  formatCurrency,
  formatNumber,
  convertPerAnnumToFortnightly,
} from 'helpers'

export const SummarySheet = (props) => {
  const isDisplayinterest = useSelector(
    (state) =>
      state.user.employer.employerGRS.displayInterestRateOnDigitalEstimate
  )

  //<TODO(VJ): below calculations should be moved to a common place
  const leaseTerm =
    props.novatedLeaseData.proposalEstimate.leaseTerm % 12 === 0
      ? props.novatedLeaseData.proposalEstimate.leaseTermYears.toString() +
        ' Years'
      : props.novatedLeaseData.proposalEstimate.leaseTerm.toString() + ' Months'

  const annualKmsText =
    formatNumber(props.novatedLeaseData.proposalEstimate.kmPerAnnum) + ' kms'

  const carRepaymentPerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.carRepaymentPerAnnumIncGST
  )

  const regoPerPay = props.exGst
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.regoPerAnnumExGST
      )
    : convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.regoPerAnnumIncGST
      )

  const compInsPerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.compInsPerAnnumIncGST
  )

  const maintenancePerPay = props.novatedLeaseData.proposalEstimate
    .maintenancePerPayIncGST
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.maintenancePerAnnumIncGST
      )
    : 0
  const tyresPerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.tyresPerAnnumIncGST
  )

  const fuelPerPay = convertPerAnnumToFortnightly(
    props.novatedLeaseData.proposalEstimate.fuelPerAnnumIncGST
  )

  const electricityPerPay = props.novatedLeaseData.proposalEstimate
    .electricityPerAnnumIncGST
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.electricityPerAnnumIncGST
      )
    : 0

  const otherRunningCostsPerPayIncGST = props.novatedLeaseData.proposalEstimate
    .otherRunningCostsPerAnnumIncGST
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.otherRunningCostsPerAnnumIncGST
      )
    : 0

  const nlFeePerPay = props.novatedLeaseData.proposalEstimate
    .nlFeePerAnnumIncGST
    ? convertPerAnnumToFortnightly(
        props.novatedLeaseData.proposalEstimate.nlFeePerAnnumIncGST
      )
    : 0

  const vehicleServiceAndMaintenanceBudget = maintenancePerPay

  return (
    <S.SummarySheet>
      <S.SummaryHeaderBlock>
        {' '}
        <img src={require(`../../../images/Oly.svg`).default} />
        <b> &nbsp; NOVATED LEASING SUMMARY SHEET</b>
      </S.SummaryHeaderBlock>
      <S.SummaryTable bordered>
        <thead>
          <tr>
            <th align="center">Item</th>
            <th align="center">Quoted Price</th>
          </tr>
        </thead>
        <tbody>
          <S.SummaryTableHeader>
            <td colSpan={2} align="center">
              <b>YOUR FORTNIGHTLY PAYMENT</b> <small>1</small>
              <br />
              <span>
                <b>(based on two month deferred lease structure)</b>
              </span>
            </td>
          </S.SummaryTableHeader>
          <tr>
            <td>Fortnightly Pre Tax Deduction (a)</td>
            <td>
              {' '}
              {formatCurrency(
                convertPerAnnumToFortnightly(
                  props.novatedLeaseData.proposalEstimate.spPreTaxDeduction
                ) +
                  convertPerAnnumToFortnightly(
                    props.novatedLeaseData.proposalEstimate.fbtPerAnnum
                  )
              )}
            </td>
          </tr>
          <tr>
            <td>Fortnightly Post Tax Deduction (b)</td>
            <td>
              {' '}
              {formatCurrency(
                convertPerAnnumToFortnightly(
                  props.novatedLeaseData.proposalEstimate.specm
                )
              )}
            </td>
          </tr>
          <tr>
            <td>Fortnightly Tax Benefit (c)</td>
            <td>
              {formatCurrency(
                convertPerAnnumToFortnightly(
                  props.novatedLeaseData.proposalEstimate.taxandMedicareSavings
                )
              )}
            </td>
          </tr>
          <tr>
            <td>
              <S.BoldText>Your Total Fortnightly Cost</S.BoldText> based on (a)
              + (b) - (c)
            </td>
            <td>
              {formatCurrency(
                convertPerAnnumToFortnightly(
                  props.novatedLeaseData.proposalEstimate.spPreTaxDeduction
                ) +
                  convertPerAnnumToFortnightly(
                    props.novatedLeaseData.proposalEstimate.fbtPerAnnum
                  ) +
                  convertPerAnnumToFortnightly(
                    props.novatedLeaseData.proposalEstimate.specm
                  ) -
                  convertPerAnnumToFortnightly(
                    props.novatedLeaseData.proposalEstimate
                      .taxandMedicareSavings
                  )
              )}
            </td>
          </tr>
          <S.SummaryTableHeader>
            <td colSpan={2} align="left">
              <b>NOVATED LEASE DETAILS</b> &nbsp;
              <span>
                <b>include the following</b>
              </span>
            </td>
          </S.SummaryTableHeader>
          <tr>
            <td>Lease Type</td>
            <td>{props.novatedLeaseData.proposalEstimate.productId}</td>
          </tr>
          <tr>
            <td>Lease Term</td>
            <td>{leaseTerm}</td>
          </tr>
          {isDisplayinterest && (
            <tr>
              <td>
                Comparison Interest Rate<small>2,3</small>
              </td>
              <td> {props.novatedLeaseData.proposalEstimate.annualRate}%</td>
            </tr>
          )}
          <tr>
            <td>
              Total Amount Financed<small>4</small>
            </td>
            <td>
              {' '}
              {formatCurrency(
                props.novatedLeaseData.proposalEstimate.financeAmount
              )}
            </td>
          </tr>
          <tr>
            <td>Annual Estimated Kilometers</td>
            <td>{annualKmsText}</td>
          </tr>
          <tr>
            <td>Residual Value (inc GST)</td>
            <td>
              {formatCurrency(
                props.novatedLeaseData.proposalEstimate
                  .leaseResidualAmountIncGST
              )}
            </td>
          </tr>
          <tr>
            <td>FBT Base Value</td>
            <td>
              {' '}
              {formatCurrency(
                props.novatedLeaseData.proposalEstimate.vehicleFBTValue
              )}
            </td>
          </tr>
          <S.SummaryTableHeader>
            <td colSpan={2} align="left">
              <b>FORTNIGHTLY RUNNING COSTS</b>
              <small>5</small> &nbsp;
              <span>
                <b>include the following</b>
              </span>
            </td>
          </S.SummaryTableHeader>
          <tr>
            <td>Novated Leasing Administration Fee</td>
            <td> {formatCurrency(nlFeePerPay)}</td>
          </tr>
          <tr>
            <td>
              Total Lease Payment (Finance Payment)<small>2</small>
            </td>
            <td> {formatCurrency(carRepaymentPerPay)}</td>
          </tr>
          <tr>
            <td>Vehicle Registration Budget </td>
            <td>{formatCurrency(regoPerPay)}</td>
          </tr>
          <tr>
            <td>Vehicle insurance Budget</td>
            <td>{formatCurrency(compInsPerPay)}</td>
          </tr>
          <tr>
            <td>Vehicle Service and Maintenance Budget</td>
            <td>{formatCurrency(vehicleServiceAndMaintenanceBudget)}</td>
          </tr>
          <tr>
            <td>Tyres Budget</td>
            <td>{formatCurrency(tyresPerPay)}</td>
          </tr>
          {fuelPerPay > 0 && (
            <tr>
              <td>
                Fuel Budget (based on fuel economy of{' '}
                <span>
                  {props.novatedLeaseData.proposalEstimate.vehicle.fuelConsumption.toFixed(
                    2
                  )}
                </span>
                L/100km,
                {props.novatedLeaseData.proposalEstimate.fuelPricePerLitre &&
                  props.novatedLeaseData.proposalEstimate.fuelPricePerLitre >
                    0 &&
                  '$' +
                    props.novatedLeaseData.proposalEstimate.fuelPricePerLitre +
                    '/litre)'}
                <br />
                <S.InfoSection>
                  *additional fuel card fees included. Caltex 27c per
                  transaction, BP no fees apply
                </S.InfoSection>
              </td>
              <td>{formatCurrency(fuelPerPay)}</td>
            </tr>
          )}
          <tr>
            <td>Other Running Costs/Optional Products</td>
            <td> {formatCurrency(otherRunningCostsPerPayIncGST)}</td>
          </tr>
          {electricityPerPay > 0 && (
            <tr>
              <td>
                Electric Budget{' '}
                {props.novatedLeaseData.proposalEstimate.electricityCostPerKm &&
                props.novatedLeaseData.proposalEstimate.electricityCostPerKm >
                  0 ? (
                  <>
                    <br />
                    <S.InfoSection>
                      based on{' '}
                      {(
                        props.novatedLeaseData.proposalEstimate
                          .electricityCostPerKm * 100
                      ).toFixed(1)}{' '}
                      cents/km
                    </S.InfoSection>
                  </>
                ) : (
                  ''
                )}{' '}
              </td>
              <td> {formatCurrency(electricityPerPay)}</td>
            </tr>
          )}
          <tr>
            <td colSpan={2}>
              <ol>
                <li>
                  Actual salary deductions may slightly differ once the novated
                  lease is established. To assist with minimising your FBT
                  liability, you will be advised of any changes to the above
                  pre-tax and post-tax fortnightly deductions.
                </li>
                <li>Based on a two-month deferred lease structure.</li>
                <li>
                  Includes the loan amount, term of the loan, repayment
                  frequency, interest rate and all fees and charges relating to
                  the Novated Lease quotation.
                </li>
                <li>
                  This means all financed costs which include the vehicle cost,
                  accessories, on-road costs, other applicable taxes, optional
                  extras, initial registration/CTP, financier’s fees, insurances
                  and membership products (where applicable).
                </li>
                <li>
                  All quoted items include GST, except vehicle registration
                </li>
              </ol>
            </td>
          </tr>
          <S.SummaryTableHeader>
            <td colSpan={2} align="left">
              <b>IMPORTANT INFORMATION</b> <br /> <br />
              <ul>
                <li>
                  <b>
                    {' '}
                    It is mandatory that you salary package with either of the
                    Salary Packaging Administrator (Oly or Smartsalary under
                    PTD0026-17) prior to entering a Novated Lease Agreement
                    under QGP0026-16.
                  </b>{' '}
                  A fortnightly salary packaging administation fee is also
                  applicable (in addition to the Novated Lease Suppliers fees),
                  for more information including a range of information
                  booklets, please refer to the Queensland Contracts Directory
                  <a
                    target="_blank"
                    href="http://qcd.govnet.qld.gov.au/Pages/Details.aspx?RecID=1696"
                  >
                    {' '}
                    http://qcd.govnet.qld.gov.au/Pages/Details.aspx?RecID=1696.
                  </a>
                </li>
                <li>
                  The implications of salary packaging a motor vehicle through a
                  novated leasing arrangement, including tax savings will depend
                  on your individual circumstances. The information in this
                  publication has been prepared by Oly for general
                  information purposes only, without taking into consideration
                  any individual circumstances. Before acting on any information
                  or entering into a novated leasing arrangement, you should
                  consider your objectives, financial situation and needs, take
                  the appropriate legal, financial or other professional advices
                  bases upon your own particular circumstances.
                  <b>
                    {' '}
                    The Queensland Government strongly recommends that you
                    obtain independent financial advice prior to entering into,
                    or changing the terms of, a salary packaging arrangement.
                  </b>
                </li>
                <li>
                  Novated Leasing Suppliers must disclose all commissions and
                  brokerage fees, refer to the Supplier’s quotation for further
                  information.
                </li>
              </ul>
            </td>
          </S.SummaryTableHeader>
        </tbody>
      </S.SummaryTable>
    </S.SummarySheet>
  )
}
